import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';

// Refactor and remove this extra bootstrap modal
export class BootstrapModal extends Component {
  constructor (props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal (event) {
    event.stopPropagation();
    if (this.props.onClose) {
      return this.props.onClose(event);
    }
    return this.props.toggleModal('');
  }

  render () {
    const {
      banner,
      addCloseIcon = true,
      header,
      footer,
      body,
      bodyClass = '',
      footerClass = '',
      modalClass = '',
      modalSize = 'sm-size',
      showModal
    } = this.props;

    return (
      showModal
        && <Modal
          show={showModal}
          backdrop="static"
          dialogClassName={`modal-dialogue ${modalSize} ${modalClass}`}
          backdropClassName="bs-backdrop"
          animation={false}
        >
          <div className="modal-banner">
            {
              banner
                ? <div className={`text-center header-banner ${banner.type}`}>
                  { banner.text }
                </div> : null
            }
            {
              addCloseIcon
                ? <button className="btn-link btn remove-click-styling float-right ico ico-sm icon-close-sidebar" onClick={this.closeModal} />
                : null
            }
          </div>
          { header
            ? <Modal.Header>
              <div className="modal-title text-center">
                {header}
              </div>
            </Modal.Header> : null
          }
          <Modal.Body bsClass={ `modal-body ${bodyClass}` }>
            { body }
          </Modal.Body>
          {
            footer
              ? <Modal.Footer bsClass={ `modal-footer ${footerClass}` }>
                {footer}
              </Modal.Footer> : null
          }
        </Modal>
    );
  }
}

BootstrapModal.propTypes = {
  banner: PropTypes.object,
  addCloseIcon: PropTypes.bool,
  header: PropTypes.object,
  footer: PropTypes.object,
  body: PropTypes.object,
  modalClass: PropTypes.string,
  bodyClass: PropTypes.string,
  footerClass: PropTypes.string,
  modalSize: PropTypes.string,
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  onClose: PropTypes.func
};

export default BootstrapModal;
